import { createApiClient } from "#/shared/api/client";

/**
 * The `url` endpoint answers `common_places`, and `place_suggestion_sort_order` where its sections
 * include the location settings. Both methods read one shared request.
 */
export const createDistanceFilterApi = ({ url }) => {
  const api = createApiClient({ baseURL: url, parse: false });

  let settings;

  function forgetSettings() {
    settings = undefined;
  }

  function getLocationSettings() {
    if (!settings) {
      settings = api.get("");
      settings.catch(forgetSettings);
    }

    return settings;
  }

  return {
    getCommonPlaces: async () => (await getLocationSettings())?.common_places ?? [],
    getPlaceSortOrder: async () => (await getLocationSettings())?.place_suggestion_sort_order ?? [],
  };
};
